import { RecordContextProvider } from 'react-admin';
import { ActivityModal } from '../components/ActivityModal.tsx';

// ActivityModal logs against the record in context, so this gives it the
// contact the follow-up is with. Open while contactId is set.
export const FollowUpModal = ({
  contactId,
  onClose,
  onSaved
}: {
  contactId: number | null;
  onClose: () => void;
  onSaved?: () => void;
}) => (
  <RecordContextProvider value={contactId === null ? undefined : { id: contactId }}>
    <ActivityModal
      open={contactId !== null}
      setOpen={(open) => {
        if (!open) onClose();
      }}
      keyName="contactId"
      resource="contact-activities"
      onSaved={onSaved}
    />
  </RecordContextProvider>
);
